module.exports = __webpack_public_path__ + "img/banner.4c723cb3.svg";